import { zodResolver } from '@hookform/resolvers/zod';
import { FC } from 'react';
import { useForm, SubmitHandler, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { SusnetImage } from '~/components/_wrapper/SusnetImage';

import {
  StyledSideForm,
  StyledFormBody,
  StyledFormLabel,
  StyledFormRow,
  StyledFormLabelRequired,
  StyledInput,
  StyledSelect,
  StyledTextarea,
  StyledFormCheckRow,
} from './form.styles';
import { StyledSideText, StyledSideTitle, StyledSidePrimaryButton } from './side.styles';

type Props = {
  form: UseFormReturn<any>;
  onSubmit: SubmitHandler<any>;
};

export const Form: FC<Props> = ({ form, onSubmit }) => {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    watch,
    setValue,
  } = form;

  const data = watch();
  const { checked } = data;

  return (
    <StyledSideForm onSubmit={handleSubmit(onSubmit)}>
      <StyledSideText>
        <StyledSideTitle>企業の方</StyledSideTitle>
        <br />
        下記フォームのご入力をお願い致します。
      </StyledSideText>
      <StyledFormBody>
        <StyledFormRow>
          <StyledFormLabel>
            貴社名<StyledFormLabelRequired>*</StyledFormLabelRequired>
          </StyledFormLabel>
          <StyledInput placeholder={'例：○○株式会社'} {...register('company')} />
        </StyledFormRow>
        <StyledFormRow>
          <StyledFormLabel>
            部署名<StyledFormLabelRequired>*</StyledFormLabelRequired>
          </StyledFormLabel>
          <StyledInput placeholder={'例：○○部'} {...register('department')} />
        </StyledFormRow>
        <StyledFormRow>
          <StyledFormLabel>
            ご担当者様のお名前<StyledFormLabelRequired>*</StyledFormLabelRequired>
          </StyledFormLabel>
          <StyledInput placeholder={'例：伏見 崇宏'} {...register('name')} />
        </StyledFormRow>
        <StyledFormRow>
          <StyledFormLabel>お役職</StyledFormLabel>
          <StyledInput placeholder={'例：代表取締役'} {...register('post')} />
        </StyledFormRow>
        <StyledFormRow>
          <StyledFormLabel>
            ご連絡先メールアドレス<StyledFormLabelRequired>*</StyledFormLabelRequired>
          </StyledFormLabel>
          <StyledInput placeholder={'例：info@ichicommons.com'} {...register('email')} />
        </StyledFormRow>
        <StyledFormRow>
          <StyledFormLabel>
            本レポートについてどのように知りましたか？
            <StyledFormLabelRequired>*</StyledFormLabelRequired>
          </StyledFormLabel>
          <div style={{ width: '100%', position: 'relative' }}>
            <StyledSelect placeholder={''} {...register('how')}>
              <option>ICHI COMMONS ホームページ</option>
              <option>取引先企業</option>
              <option>取引先NPO/SPO</option>
              <option>ICHI.PRESS</option>
              <option>PR TIMES</option>
              <option>その他</option>
            </StyledSelect>
            <SusnetImage
              src={'/survey/triangle.svg'}
              style={{
                position: 'absolute',
                right: 10,
                top: 10,
              }}
              width={18}
              height={18}
            />
          </div>
        </StyledFormRow>
        <StyledFormRow>
          <StyledFormLabel>本レポートご請求の背景</StyledFormLabel>
          <StyledTextarea
            placeholder={'具体的な活用先があればお教えください'}
            {...register('background')}
          />
        </StyledFormRow>
        <StyledFormCheckRow>
          <SusnetImage
            src={`/survey/check-square${!checked ? '-not-checked' : ''}.svg`}
            width={24}
            height={24}
            onClick={() => {
              setValue('checked', !checked, { shouldValidate: true });
            }}
          />
          <a href={'/privacy'} target={'_blank'} rel='noreferrer'>
            プライバシーポリシーに同意する
          </a>
        </StyledFormCheckRow>
        <StyledSidePrimaryButton disabled={!isValid}>送信</StyledSidePrimaryButton>
      </StyledFormBody>
    </StyledSideForm>
  );
};
